module.exports = __webpack_public_path__ + "static/media/sliceAndDice.1aa87df2.png";